import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import Login from '../views/Login/Login.vue' // 添加这行导入Login组件
import Peason from '../views/Peason/index.vue'
import Admin from '../views/Admin/index.vue'
import Parents from '../views/Parents/index.vue'
import Students from '../views/Students/index.vue'
// 异步
const AllLessions = ()=>import('../views/AllLessions/AllLessions.vue')
const Bgc = ()=>import('../views/Teacher/bgc.vue')
const stuBgc = ()=>import('../views/Students/bgc.vue')
const Teaindex = ()=>import('../views/Teacher/index.vue')
const HelpingStu = ()=>import('../views/Teacher/helpingStu.vue')
const Counsellor = ()=>import('../views/Counsellor/index.vue')
const Verify = ()=>import('../views/Counsellor/verify.vue')
const Allstudents = ()=>import('../views/Counsellor/Allstudents.vue')
const Assignment = ()=>import('../views/Counsellor/Assignment.vue')
const Over = ()=>import('../views/Counsellor/Over.vue')
const Summary = ()=>import('../views/Counsellor/Summary.vue')
const LeaderList = ()=>import('../views/Home/LeaderList.vue')
const CourseList = ()=>import('../views/Home/CourseList.vue')
const OverPerson = ()=>import('../views/Peason/OverPerson.vue')
// const Parents = ()=>import('../views/Parents/index.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login, // 确保这里使用的是导入的Login组件
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path:'/alllessions',
    name:'AllLessions',
    component: AllLessions
  },
  {
    path:'/bgc',
    name:'Bgc',
    component: Bgc
  },
    {
    path:'/leaderlist',
    name:'LeaderList',
    component: LeaderList
  },
      {
    path:'/courselist',
    name:'CourseList',
    component: CourseList
  },
 
  {
    path:'/stubgc',
    name:'stuBgc',
    component: stuBgc
  },
    {
    path:'/verify',
    name:'Verify',
    component: Verify
  },
  {
    path:'/over',
    name:'Over',
    component: Over
  },
    {
    path:'/summary',
    name:'Summary',
    component: Summary
  },
      {
    path:'/allstudents',
    name:'Allstudents',
    component: Allstudents
  },
  {
    path:'/assignment',
    name:'Assignment',
    component: Assignment
  },
  {
    path:'/teaindex',
    name:'Teaindex',
    component: Teaindex
  },
    {
    path:'/students',
    name:'Students',
    component: Students
  },
    {
    path:'/counsellor',
    name:'Counsellor',
    component: Counsellor
  },
    {
    path:'/parents',
    name:'Parents',
    component: Parents
  },
  {
    path:'/helpingStu',
    name:'HelpingStu',
    component: HelpingStu
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path:'/peason',
    name:'Peason',
    component: Peason
  },
    {
    path:'/overperson',
    name:'OverPerson',
    component:OverPerson
  }
]

const router = new VueRouter({
  routes
})

export default router